<script lang="ts">
    import { onMount } from "svelte";
    import type { PagedResponseOfTagListEntry } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../../store/stores";
    import CreateNewTag from "./CreateNewTag.svelte";

    let results: PagedResponseOfTagListEntry = null;
    let createNewTag: boolean = false;

    const getUsers = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .tagClient.listTags({})
                .then((tags) => {
                    console.log(tags);
                    results = tags;
                });
        });
    };

    onMount(() => getUsers());
</script>

<div class="panel-block">
    <p class="control has-icons-left">
        <input class="input is-primary" type="text" placeholder="Search" />
        <span class="icon is-left">
            <i class="fas fa-search" aria-hidden="true" />
        </span>
    </p>
</div>
{#if results && results.entries.length > 3}
    {#each results.entries as tagListEntry}
        <div class="panel-block">
            <div class="field is-grouped is-grouped-multiline">
                {#each tagListEntry.predefinedValues as value}
                    <div class="control">
                        <div class="tags has-addons">
                            <span class="tag">{tagListEntry.name}</span>

                            <span class="tag is-primary">{value}</span>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    {/each}
{:else if results && !createNewTag}
    <div class="panel-block is-active">
        <div class="panel-block is-active">
            <div>{results.entries.length} Tags gefunden</div>
        </div>
    </div>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a class="panel-block is-active" on:click={() => (createNewTag = true)}>
        <a class="panel-block is-active">
            <span class="panel-icon">
                <i class="fas fa-plus" />
            </span>
            <div>Neuen Tag anlegen</div>
        </a>
    </a>
{:else if results && createNewTag}
    <CreateNewTag handleCloseEvent={() => (createNewTag = false)} />
{/if}
